<template>
<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-cycle`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.7075 6.43282C10.7075 6.43282 9.40454 9.66881 5.14388 8.10274L5.47136 7.30586C5.47136 7.30586 5.76145 6.52352 4.75964 6.71045L1.94458 7.45817C1.94458 7.45817 1.30555 7.65134 1.60395 8.21075L3.21641 10.9455C3.37565 11.2224 3.81736 11.3637 4.0126 10.8368L4.33454 10.0371C4.33454 10.0371 9.60532 12.0408 10.7068 6.43282H10.7075ZM1.29171 5.38669C1.29171 5.38669 2.67431 2.18462 6.89481 3.85662L6.54726 4.64589C6.54726 4.64589 6.23778 5.42131 7.24513 5.25861L10.0775 4.5822C10.0775 4.5822 10.7214 4.40565 10.4368 3.83793L8.89359 1.06442C8.72328 0.759097 8.30372 0.655938 8.09463 1.15165L7.75262 1.94438C7.75193 1.94438 2.53238 -0.190793 1.29102 5.38669H1.29171Z" :fill="useCurrentColor ? 'currentColor' : '#9B59F7'"/></svg>
</template>
<script>

export default {
  name: 'IconColorCycle',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
